import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import AllocationHistory from './AllocationHistory';
const AllocationHistoryModal = observer(() => {
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const setAllocationHistoryModalIsOpen = store.allocations.setAllocationHistoryModalIsOpen;
  const handleClose = () => {
    setAllocationHistoryModalIsOpen(false);
    store.allocations.setHistoryData('', '');
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    handleClose: handleClose,
    handleOpen: () => setAllocationHistoryModalIsOpen(true),
    isOpen: store.allocations.allocationHistoryModalIsOpen,
    noPadding: true,
    title: t('allocations.allocation_history_preview', {
      monthsCounter: 6
    }),
    variant: "large"
  }, /*#__PURE__*/React.createElement(AllocationHistory, null));
});
export default AllocationHistoryModal;